/**
 * Client-side effective plan resolution (mirrors functions/src/planResolution.ts).
 */
import { normalizeSubscriptionPlan } from '../constants/uploadLimits';

/**
 * @param {import('firebase/firestore').DocumentData | null | undefined} billing
 * @param {number} [now]
 */
export function resolveEffectivePlan(billing, now = Date.now()) {
  const override = billing?.manualPlanOverride;
  const expiresAt =
    override && typeof override.expiresAt === 'number' && Number.isFinite(override.expiresAt)
      ? override.expiresAt
      : null;
  const overridePlan =
    override?.plan != null ? normalizeSubscriptionPlan(override.plan) : null;
  const overrideActive = !!(overridePlan && overridePlan !== 'free' && expiresAt != null && now < expiresAt);

  if (overrideActive) {
    return {
      plan: overridePlan,
      source: 'manual_trial',
      expiresAt,
      overrideActive: true,
      overrideExpired: false,
      manualPlanOverride: override,
    };
  }

  const subPlan = normalizeSubscriptionPlan(billing?.subscription?.plan || 'free');
  const overrideExpired = !!(overridePlan && expiresAt != null && now >= expiresAt);

  return {
    plan: subPlan,
    source: 'subscription',
    expiresAt: overrideExpired ? expiresAt : null,
    overrideActive: false,
    overrideExpired,
    manualPlanOverride: overrideExpired ? override : null,
  };
}
